<!-- `https://res.cloudinary.com/uwm/image/upload/w_450,h_354,c_fill,g_auto/${card.uri}` -->
<template>
	<section :class="card.category">
		<!-- TODO: Need the click event to be dynamic such as selectVideoContent(card) or selectFlyerContent(card)
        TODO: Jon, I am missing something from your setup we need to add class 'selected' to the div.design.-->
		<div
			class="preview-template-wrapper"
			:class="{ disabled: disabled, enabled: !disabled }"
		>
			<div
				tabindex="0"
				class="design"
				@keydown.enter="handleClick"
				role="button"
				:aria-label="`${alertName} Preview Template ${card.id}`"
				:class="{ selected: isChecked }"
				@click="handleClick"
				:disabled="disabled"
			>
				<div class="b360-fake-img-border" :disabled="disabled"></div>
				<img
					:src="card.link"
					class="b360-large-image-radio"
					:alt="`${alertName} Preview Template ${card.id} Thumbnail`"
					:disabled="disabled"
				/>
				<Radio
					:radioId="`${alertName}-select-card-${card.id}`"
					radioGroupName="designGroup"
					:isChecked="isChecked"
					:radioDescription="`media group radio`"
					:disabled="disabled"
				/>
			</div>
			<!-- TODO: Make link route properly <router-link :to="route" class="preference-center-template-link">Preview Template</router-link> -->
			<button
				:id="`${alertName}-show-modal-${card.id}`"
				v-if="showPreview"
				@click="showModal = true"
				class="preference-center-template-link"
				type="button"
			>
				Preview Template
			</button>
			<!-- <span class="preference-center-template-link">Preview Template</span> -->
			<Modal
				v-if="showModal"
				:show="showModal"
				@close="showModal = false"
				:modalTitle="`${alertName} Preview Template ${card.id}`"
				cancelBtnName="Close"
				class="md"
			>
				<img
					:src="card.link"
					:alt="`${alertName} Preview Template`"
					slot="modalContent"
				/>
			</Modal>
		</div>
	</section>
</template>
<script>
import Radio from '@/components/global/Radio.vue';
import Modal from '@/components/global/Modal.vue';

export default {
	name: 'PreferenceCenterImageRadio',
	components: {
		Radio,
		Modal,
	},
	props: {
		index: String,
		default: Boolean,
		card: Object,
		alertName: String,
		selectType: String,
		isChecked: Boolean,
		disabled: Boolean,
		showPreview: Boolean,
	},
	data() {
		return {
			// This hides the display of the modal until it is activated.
			showModal: false,
		};
	},
	methods: {
		handleClick() {
			if (this.disabled) return;
			// send to parent to handle other radio components
			this.$emit('clicked', this.card.id);
		},
	},
};
</script>

<style lang="scss" scoped>
.preview-template-wrapper {
	display: flex;
	flex-direction: column;
	align-items: center;
	outline: none;

	.b360-large-image-radio {
		max-width: 100%;
		display: block;
		border-radius: $b360-border-radius-base;
	}

	.design {
		@include rem(margin-bottom, 12px);
		border-radius: $b360-border-radius-medium;
		position: relative;
		display: block;
		outline: none;

		&.enabled {
			&:hover,
			&:focus {
				.b360-fake-img-border {
					box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;
				}
				.custom-radio {
					background-color: $brand-teal;
					svg {
						fill: white;
					}
				}
			}
		}
		&.disabled {
			&:hover,
			&:focus {
				.b360-fake-img-border {
					box-shadow: inset 0 0 0 $b360-border-width-medium $border-color-light;
				}
				.custom-radio {
					background-color: $border-color-light;
					svg {
						fill: white;
					}
				}
			}
		}
	}

	.b360-fake-img-border {
		box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
		display: flex;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		border-radius: $b360-border-radius-base;
	}

	.custom-radio {
		position: absolute;
		top: 10px;
		right: 10px;
		z-index: 1;
		&.disabled {
			cursor: not-allowed;
		}
	}

	&.disabled {
		cursor: not-allowed;
		.selected {
			.b360-fake-img-border {
				box-shadow: inset 0 0 0 $b360-border-width-medium
					$b360-color--gray__darker;
			}
			svg {
				@include rem('width', 12px);
				@include rem('height', 12px);
				fill: $white;
				transition: fill $b360-motion-duration--shorter
					$b360-motion-easing--accelerate;
			}
		}
		.checked {
			background-color: $b360-color--gray__darker;
			box-shadow: inset 0 0 0 $b360-border-width-thin $b360-color--gray__darker;
		}
	}
	&.enabled {
		cursor: pointer;
		.selected {
			.b360-fake-img-border {
				box-shadow: inset 0 0 0 $b360-border-width-medium $brand-blue;
			}
			svg {
				@include rem('width', 12px);
				@include rem('height', 12px);
				fill: $white;
				transition: fill $b360-motion-duration--shorter
					$b360-motion-easing--accelerate;
			}
		}

		.checked {
			background-color: $brand-blue;
			box-shadow: inset 0 0 0 $b360-border-width-thin $brand-blue;
		}
	}
}

.preference-center-template-link {
	@include typo--roboto__medium;
	font-size: $b360-font-size--small;
	color: $brand-blue;
	border: unset;
	background-color: transparent;
	cursor: pointer;
}

.design:hover .custom-radio svg,
.design:focus .custom-radio svg {
	fill: white;
}
</style>
